module.exports = __webpack_public_path__ + "images/ffd37713fc44d948cb64514cf913e71e.svg";